import React from "react"
import PropTypes from "prop-types"
import {Button, Card, Col, Row} from "antd"
import {compose} from 'recompose'
import {withRouter} from "react-router";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as ManageActions from "../../reducers/lovManage";
import EditModal from "./EditModal";
import LovTable from "./LovTable";
import OverviewTree from "./OverviewTree";

class LovManageView extends React.Component {
    
    static propTypes = {
        overview: PropTypes.object.isRequired,
        getOverview: PropTypes.func.isRequired,
        getLovs: PropTypes.func.isRequired,
        getMapping: PropTypes.func.isRequired,
        lovs: PropTypes.array.isRequired,
        fetchingOverview: PropTypes.bool.isRequired,
        fetchingLovs: PropTypes.bool.isRequired,
        fetchingMapping: PropTypes.bool.isRequired,
        saving: PropTypes.bool.isRequired,
        selectedType: PropTypes.string,
        saveLov: PropTypes.func.isRequired,
        mappings: PropTypes.array.isRequired
    };


    state = {
        showEditModal: false,
        codeToEdit: null,
        isEdit: false,
        lovSelected: 'AP_PERS_SUBSPC',
    };
    
    componentDidMount() {
        const code = this.props.location.pathname.substr('/lov/manage/'.length);
        // this.setState({lovSelected: code});
        this.setState({lovSelected: code}, () =>
            this.props.getLovs(code)
                .then(this.props.getOverview)
        );
    }
    
    handleTypeChange = (selectedKeys) => {
        const code = selectedKeys[0];
        this.props.getLovs(code);
        this.setState({codeToEdit: null, lovSelected: code});
        this.props.history.push('/lov/manage/'+code);
    };
    
    handleEdit = () => {
        this.setState({showEditModal: true, isEdit: true})
    };
    
    handleCreate = () => {
        this.setState({showEditModal: true, isEdit: false})
    };
    
    onSelectChange = (code) => {
        console.log(code);
        this.setState({codeToEdit: code});
        this.props.getMapping(code);
    };
    
    closeEditModal = () => this.setState({showEditModal: false});
    
    render() {
        console.log(this.props)
        const {overview, fetchingOverview, fetchingLovs, lovs, saving, selectedType, saveLov, mappings, fetchingMapping} = this.props;
        const {showEditModal, codeToEdit, isEdit, lovSelected} = this.state;
        const lovToEdit = lovs.filter(lov => lov.code === codeToEdit)[0] || {};
        console.log("Love to edit", lovToEdit)
        console.log("SAVE", lovs)

        const title = <Row>
            <Col span={2}>
                Manage LOVs
            </Col>
            <Col span={3} offset={19}>
                <Button type="primary" icon="plus" onClick={this.handleCreate} disabled={!selectedType}>Add</Button>
                <span> </span>
                <Button icon="edit" onClick={this.handleEdit} disabled={!codeToEdit}>Edit</Button>
            </Col>
        </Row>;

        return <Card title={title} className="full-height">
            <div className="lov-display">

            <Row gutter={20}>
                <Col span={3}>
                    <OverviewTree fetchingOverview={fetchingOverview} overview={overview} selectedType={lovSelected}
                                  handleTypeChange={this.handleTypeChange}/>
                </Col>
                <Col span={12}>
                        <LovTable dataSource={lovs} loading={fetchingLovs} handleEdit={this.handleEdit} isLocal={false}
                                  onSelectChange={this.onSelectChange}/>

                </Col>
                <Col span={9}>
                    <LovTable loading={fetchingMapping} dataSource={mappings} handleEdit={this.handleEdit} isLocal={true}/>
                </Col>
            </Row>
            </div>
            <EditModal visible={showEditModal} lov={lovToEdit} close={this.closeEditModal} saving={saving}
                       saveLov={saveLov} isEdit={isEdit} />

        </Card>

    }
}



const mapStateToProps = state => ({
    overview: state.lovManage.overview,
    lovs: state.lovManage.lovs,
    fetchingOverview: state.lovManage.fetchingOverview,
    fetchingLovs: state.lovManage.fetchingLovs,
    fetchingMapping: state.lovManage.fetchingMapping,
    saving: state.lovManage.saving,
    selectedType: state.lovManage.selectedType,
    mappings: state.lovManage.mappings
});

const mapDispatchToProps = dispatch => ({
    getOverview: bindActionCreators(ManageActions, dispatch).getOverview,
    getLovs: bindActionCreators(ManageActions, dispatch).getLovs,
    saveLov: bindActionCreators(ManageActions, dispatch).saveLov,
    getMapping: bindActionCreators(ManageActions, dispatch).getMapping
});

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(LovManageView)


// WEBPACK FOOTER //
// ./src/js/lovs/manage/LovManageView.js